import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/components/nav.scss'
import '../styles/phantom.scss'
import { motion } from 'framer-motion'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'

const top = {
    open: { y: '9px', rotate: 45 },
    closed: { y: 0 },
}

const middle = {
    open: { opacity: 0, transition: { duration: 0.1 } },
    closed: { opacity: 1 },
}

const bottom = {
    open: { y: '-9px', rotate: -45 },
    closed: { y: 0 },
}

const nav = {
    open: { y: '0' },
    closed: { y: '-100%' },
}

const Nav = () => {
    const [isOpen, setOpen] = useState(false)
    let location = useLocation()

    return (
        <>
            <div className='relative'>
                <nav className='nav-bar'>
                    <div className='desktop-nav'>
                        <Link to='/' className='nav-link'>
                            HOME
                        </Link>
                        <Link to='/phantom-brave' className='nav-link'>
                            PHANTOM BRAVE
                        </Link>
                        <Link to='/soul-nomad' className='nav-link'>
                            SOUL NOMAD
                        </Link>
                        <Link to='/products' className='nav-link'>
                            PRODUCTS
                        </Link>
                        <Link to='/media' className='nav-link'>
                            MEDIA
                        </Link>
                    </div>
                    <div className='mobile-nav'>
                        <div className='hamburger-container' onClick={() => setOpen(!isOpen)}>
                            <div className='hamburger'>
                                <motion.div
                                    className='ham'
                                    animate={isOpen ? 'open' : 'closed'}
                                    variants={top}
                                ></motion.div>
                                <motion.div
                                    className='ham'
                                    animate={isOpen ? 'open' : 'closed'}
                                    variants={middle}
                                ></motion.div>
                                <motion.div
                                    className='ham'
                                    animate={isOpen ? 'open' : 'closed'}
                                    variants={bottom}
                                ></motion.div>
                            </div>
                        </div>
                    </div>
                    <motion.div
                        className='hidden'
                        animate={isOpen ? 'open' : 'closed'}
                        transition={{ ease: 'easeInOut' }}
                        variants={nav}
                    >
                        <Link to='/' className='nav-link' onClick={() => setOpen(!isOpen)}>
                            HOME
                        </Link>
                        <Link to='/phantom-brave' className='nav-link' onClick={() => setOpen(!isOpen)}>
                            PHANTOM BRAVE
                        </Link>
                        <Link to='/soul-nomad' className='nav-link' onClick={() => setOpen(!isOpen)}>
                            SOUL NOMAD
                        </Link>
                        <Link to='/products' className='nav-link' onClick={() => setOpen(!isOpen)}>
                            PRODUCTS
                        </Link>
                        <Link to='/media' className='nav-link' onClick={() => setOpen(!isOpen)}>
                            MEDIA
                        </Link>
                    </motion.div>
                    {location.pathname === '/phantom-brave' && (
                        <>
                            <div
                                className='pb2-banner-desktop'
                                style={{
                                    // position: 'relative',

                                    backgroundColor: 'white',
                                    paddingTop: '10px',
                                    paddingBottom: '10px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'between',
                                }}
                            >
                                <div style={{ width: 'auto' }}>
                                    <h1
                                        className='pb2-text-gradient pb2-banner-desktop'
                                        style={{
                                            fontSize: '1.5vw',
                                            fontFamily: 'Humming',
                                            lineHeight: '3vw',
                                            textAlign: 'center',
                                        }}
                                    >
                                        Phantom Brave: The Lost Hero Coming 2025
                                    </h1>
                                </div>
                                <div style={{ width: 'auto', paddingLeft: '20px' }} className='pb2-banner-desktop'>
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href='https://nisamerica.com/phantombrave-the-lost-hero/'
                                    >
                                        <img
                                            style={{ maxWidth: '300px' }}
                                            className='pb2-button '
                                            src='./img/logos/pb2-button.jpg'
                                            alt='Phantom Brave 2 link'
                                        />{' '}
                                    </a>{' '}
                                </div>{' '}
                            </div>{' '}
                        </>
                    )}
                </nav>{' '}
                <div
                    style={{ position: 'fixed', top: '80px', right: '5px', zIndex: '2', maxWidth: '240px' }}
                    className='pb2-banner-mobile'
                >
                    <a target='_blank' rel='noreferrer' href='https://nisamerica.com/phantombrave-the-lost-hero/'>
                        <img
                            style={{ margin: 'auto', maxWidth: '300px' }}
                            className='pb2-button '
                            src='./img/logos/pb2-button-mobile.png'
                            alt='Phantom Brave 2 link'
                        />{' '}
                    </a>{' '}
                </div>{' '}
            </div>
        </>
    )
}

export default Nav
